import type { IAPI } from '../../apiResponse';
import type { IFeedItem } from '../../feed/getFeed/get-feed-request';
import type { IRequestOptions } from '../../httpClient';
import { getRequest } from '../../httpClient';

export async function getChallengeFeedItemV1Api(id: number, options?: IRequestOptions) {
  return getRequest<IAPI<IFeedItem>>({
    path: `/challenges/${id}/feed-item/v1`,
    options,
  });
}
